export default __webpack_public_path__ + "static/media/successCat.f3578dc7.png";